import React, { ReactElement, memo } from 'react'
import Grid from '@sport1/react-elements/Grid'
import SkeletonImage from '../SkeletonHelpers/SkeletonImage'
import SkeletonTexts from '../SkeletonHelpers/SkeletonTexts'
import { TestID } from '../../utils/PropTypesDefinitions'

export type BigTeaserSkeletonProps = {
    isTopStory?: boolean
} & TestID

const BigTeaserSkeleton = ({
    isTopStory = false,
    testID,
}: BigTeaserSkeletonProps): ReactElement => {
    return (
        <Grid noExpand testID={testID} backgroundColor="pearl">
            <SkeletonImage height={isTopStory ? 211 : 193} />
            <Grid noExpand marginTop={5} marginX={isTopStory ? 5 : 0} height={71}>
                <SkeletonTexts />
            </Grid>
        </Grid>
    )
}

export default memo(BigTeaserSkeleton)
